// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"common","945":"dashboard"}[chunkId] || chunkId) + "." + {"23":"1cdc8768","76":"f6cfaa9f","945":"1cd24744"}[chunkId] + ".js";
};